import { Injectable } from '@angular/core';
import { ApiUrlService } from '../shared-services/api-url.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfiguratorService {
  constructor(private base_url: ApiUrlService, private http: HttpClient) {}
  createProvider(req: any): Observable<any> {
    const url = `${this.base_url.BASE_PROVIDER}/create`;
    return this.http.post(url, req);
  }
  getAllProviderWithPagination(paginationData: any, type: any,partnerId: any): Observable<any> {
    const url = `${this.base_url.BASE_PROVIDER}/get_with_paginate?limit=${paginationData.limit}&currentPage=${paginationData.currentPage}&txType=${type}&userId=${partnerId}`;
    return this.http.get(url);
  }
  getAllProviderWithSearch(paginationData: any,searchData:any,filterData:any): Observable<any> {
    const url = `${this.base_url.BASE_PROVIDER}/get_with_paginate?limit=${paginationData.limit}&currentPage=${paginationData.currentPage}&providerName=${searchData}&txType=${filterData}&userId=${paginationData.userId}`;

    return this.http.get(url);
  }
   getAllProviderWithFilter(paginationData: any,filterData: any,searchData:any): Observable<any> {
    const url = `${this.base_url.BASE_PROVIDER}/get_with_paginate?limit=${paginationData.limit}&currentPage=${paginationData.currentPage}&txType=${filterData}&providerName=${searchData}&userId=${paginationData.userId}`;
    return this.http.get(url);
  }
  getProviderBuilder(id: any): Observable<any> {
    const url = `${this.base_url.BASE_PROVIDER}/${id}`;
    return this.http.get(url);
  }
  UpdateProvider(req: any): Observable<any> {
    const url = `${this.base_url.BASE_PROVIDER}/update/${req?.id}`;
    return this.http.put(url, req);
  }
  deleteProvider(DistReq: string): Observable<any> {
    const url = `${this.base_url.BASE_PROVIDER}/delete`;
    return this.http.post(url, DistReq);
  }
  // SCHEME MANGER SERVICES BASE_SCHEME_MANAGER
  createScheme(req: any): Observable<any> {
    const url = `${this.base_url.BASE_SCHEME_MANAGER}/create`;
    console.log(url);
    return this.http.post(
      `${this.base_url.BASE_SCHEME_MANAGER}/create`,
      req
    );
  }
  getAllSchemeWithPagination(params: {
    limit?: number;
    currentPage?: number;
  }): Observable<any> {
    const url = `${this.base_url.BASE_SCHEME_MANAGER}/get_with_paginate`;
    return this.http.get(url, {
      params,
    });
  }

  getAllSchemes() {
    return this.http.get(`${this.base_url.BASE_SCHEME_MANAGER}/all`);
  } 
  
  getSchemesReseller(params: any) {
    return this.http.get(`${this.base_url.BASE_SCHEME_MANAGER}/get`, {params});
  }  
  
  getAllPartner(type: string) {
    return this.http.get(`${this.base_url.GET_USER_DETAILS}/all?type=${type}`);
}

  getSchemeBuilder(id: any): Observable<any> {
    const url = `${this.base_url.BASE_SCHEME_MANAGER}/${id}`;
    return this.http.get(url);
  }
  UpdateScheme(req: any, schemeId:any): Observable<any> {
    const url = `${this.base_url.BASE_SCHEME_MANAGER}/update/${schemeId}`;
    return this.http.put(url, req);
  }
  deleteScheme(DistReq: string): Observable<any> {
    const url = `${this.base_url.BASE_SCHEME_MANAGER}/delete`;
    return this.http.post(url, DistReq);
  }

  getAppConfigurationDetail() {
    return this.http.get(`${this.base_url.GET_APP_CONFIGURATION_DETAIL}`);
  }
  
}
